import React, {useContext} from 'react';
import {AppContext} from '../contexts/AppContext';
import ActiveFilters from './Common/ActiveFilters';
import SearchField from './Filters/SearchField';
import {formatDate, getRoomsFromFilters, getTotalPax, translate} from '../helpers/base';
import clsx from 'clsx';

const Header = () => {

    const {
        selectedFilters,
        setIsBookingBoxOverlayVisible,
        setIsFilterOverlayVisible,
        handleToggleMap,
        poolEnquiryData,
        showMap,
        isMobile,
        locale,
    } = useContext(AppContext);
    
    const handleBookingBoxButtonClick = () => {
        setIsBookingBoxOverlayVisible(true);
    };

    const handleMapButtonClick = () => {
        handleToggleMap();
    };

    const handleFilterButtonClick = () => {
        setIsFilterOverlayVisible(true);
    };

    const checkinDate = selectedFilters.checkin ? new Date(selectedFilters.checkin) : undefined;
    const checkoutDate = selectedFilters.checkout ? new Date(selectedFilters.checkout) : undefined;
    const selectedRooms = getRoomsFromFilters(selectedFilters);
    const totalPax = getTotalPax(selectedRooms);
    const isOccupancySelected = totalPax > 0 && checkinDate && checkoutDate;

    if (isMobile) {
        return (
            <div className="accommodation-overview--header-mobile">
                <div className="accommodation-overview--header-mobile-top">
                    <label className="booking-box-overview--label" aria-label={translate('booking-box-mobile.toggleDateAndPersons')} onClick={handleBookingBoxButtonClick}>
                        {isOccupancySelected ? <>
                            <div className="booking-box-overview--label--period">
                                <div className="booking-box-overview--label--date-from">{formatDate(checkinDate, locale)}</div>
                                -
                                <div className="booking-box-overview--label--date-to">{formatDate(checkoutDate, locale)}</div>
                            </div>,
                            <div className="booking-box-overview--label--persons">
                                <span>{totalPax}</span> {translate(totalPax === 1 ? 'booking-box.guest' : 'booking-box.guests')}
                            </div>
                        </> : <>
                            <div className="booking-box-overview--label--persons">
                                {translate('booking-box.toggleDateAndPersons')}
                            </div>
                        </>}
                        <i className="icon icon--diverses-edit">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                      d="m10.542 4.096 3.362 3.362M3.145 11.493l3.362 3.362m-.336.336 9.75-9.75a.951.951 0 0 0 0-1.345l-2.017-2.017a.951.951 0 0 0-1.345 0l-9.75 9.75L1.8 16.2l4.371-1.009Z"/>
                            </svg>
                        </i>
                    </label>
                    <label onClick={handleMapButtonClick} className={clsx('btn-map', showMap && 'is-active')}>
                        <i className="icon icon--diverses-map_marker">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 19">
                                <path stroke="#000" strokeMiterlimit="10" strokeWidth="2"
                                      d="M8.7 1.2c-2.841 0-5.1 2.418-5.1 5.46 0 4.056 5.1 10.14 5.1 10.14s5.1-6.084 5.1-10.14c0-3.042-2.331-5.46-5.1-5.46Zm0 7.332c-1.02 0-1.821-.858-1.821-1.95s.801-1.95 1.821-1.95 1.822.858 1.822 1.95c-.073 1.092-.875 1.95-1.822 1.95Z"/>
                            </svg>
                        </i>
                    </label>
                </div>
                <div className="accommodation-overview--header-mobile-bottom">
                    <SearchField/>
                    <label className="btn btn-primary btn-sm" onClick={handleFilterButtonClick}>
                        <i className="icon icon--diverses-filter">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
                                <path stroke="#000000" strokeWidth="2" d="M6 4.266c0 1.362-1.12 2.466-2.5 2.466S1 5.628 1 4.266 2.12 1.8 3.5 1.8 6 2.904 6 4.266Zm0 0h13m-5 9.468c0-1.362 1.12-2.466 2.5-2.466s2.5 1.104 2.5 2.466-1.12 2.466-2.5 2.466-2.5-1.104-2.5-2.466Zm0 0H1"/>
                            </svg>
                        </i>
                    </label>
                </div>
            </div>
        );
    }

    return (
        <div className="accommodation-overview--header">
            <div className="accommodation-overview--header-left">
                <div className="area--text">
                    <small dangerouslySetInnerHTML={{__html: translate('accommodation-overview.filter.activeFilters')}} />
                </div>
                <label className="booking-box--label" aria-label={translate('booking-box.toggleDateAndPersons')} onClick={handleBookingBoxButtonClick}>
                    {isOccupancySelected ? <>
                        <div className="booking-box--label--period">
                            <div className="booking-box--label--date-from">{formatDate(checkinDate, locale)}</div>
                            -
                            <div className="booking-box--label--date-to">{formatDate(checkoutDate, locale)}</div>
                        </div>,
                        <div className="booking-box--label--persons">
                            <span>{totalPax}</span> {translate(totalPax === 1 ? 'booking-box.guest' : 'booking-box.guests')}
                        </div>
                    </> : <>{translate('booking-box.toggleDateAndPersons')}</>}
                    <i className="icon icon--diverses-edit">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                            <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                  d="m10.542 4.096 3.362 3.362M3.145 11.493l3.362 3.362m-.336.336 9.75-9.75a.951.951 0 0 0 0-1.345l-2.017-2.017a.951.951 0 0 0-1.345 0l-9.75 9.75L1.8 16.2l4.371-1.009Z"/>
                        </svg>
                    </i>
                </label>
            </div>
            <div className="accommodation-overview--pills pill-container">
                <ActiveFilters />
            </div>
            <button type="button" className="btn btn-text btn-sm btn-pool-enquiry js-pool-enquiry__toggle js-pool-enquiry__counter" data-count={poolEnquiryData.length} data-disable-text={translate('accommodation-overview.poolInquiry.stop')}>
                {translate('accommodation-overview.poolInquiry.start')}
            </button>
        </div>
    );
}

export default Header;
